document.addEventListener("DOMContentLoaded", () => {

  const wholesalePage = document.querySelector(".wholesale-page");
  if (!wholesalePage) return;

  const shippingThreshold =
    Number(wholesalePage.dataset.freeShipping) || 250;

  /*
  =====================================
  Wholesale Pricing Data
  =====================================
  */

  const WHOLESALE_PRICING = {};

  /*
  =====================================
  Initialize Product Card
  =====================================
  */

  function initCard(card) {

    if (card.dataset.initialized === "true") return;
    card.dataset.initialized = "true";

    const select = card.querySelector(".variant-dropdown");
    const priceBox = card.querySelector("[data-case-price]");
    const addButton = card.querySelector(".add-cart-btn");

    if (!select) return;

function updateProduct() {

  const option = select.options[select.selectedIndex];

  const price = Number(option.dataset.price);
  const qty = Number(option.dataset.qty);
  const variantId = option.value;

  // Update case price
  priceBox.innerHTML = money(price);

  // Update Add button
  addButton.dataset.variant = variantId;

  // Calculate unit price
  const unitPrice = (price / 100) / qty;

  // const unitPriceBox = card.querySelector("[data-unit-price]");
  // const saveBadge = card.querySelector("[data-save]");
  const saveHint = card.querySelector("[data-save-hint]");
  const bestPrice = card.querySelector("[data-best-price]");

  // Find cheapest unit price
  let lowest = Infinity;

  select.querySelectorAll("option").forEach(opt => {
    const p = Number(opt.dataset.price) / 100;
    const q = Number(opt.dataset.qty);
    lowest = Math.min(lowest, p / q);
  });

  // Show current unit price
  // unitPriceBox.textContent =
  //   money(unitPrice * 100).replace(".00", "") + "/unit";

  // Savings
  const savePercent = Math.round(
    ((unitPrice - lowest) / unitPrice) * 100
  );

  // if (savePercent > 0) {
  //   saveBadge.textContent = `(Save ${savePercent}%)`;
  // } else {
  //   saveBadge.textContent = "";
  // }

  // Bottom message
  if (unitPrice <= lowest) {

  saveHint.textContent = "";
  bestPrice.style.display = "block";

} else {

  saveHint.textContent =
    `Upgrade to 100 units and save ${savePercent}%`;

  bestPrice.style.display = "none";

}

  // Update option labels
  select.querySelectorAll("option").forEach(opt => {

    const p = Number(opt.dataset.price) / 100;
    const q = Number(opt.dataset.qty);

    const perUnit = p / q;

    const save = Math.round(
      ((perUnit - lowest) / perUnit) * 100
    );

    if (save > 0) {
      opt.textContent =
        `Case of ${q} — ${money(perUnit * 100).replace(".00","")}/unit (Save ${save}%)`;
    } else {
      opt.textContent =
        `Case of ${q} — ${money(perUnit * 100).replace(".00","")}/unit`;
    }

  });

  calculateMargin(card, variantId, price);

}

    select.addEventListener("change", updateProduct);

    updateProduct();

    /*
    Quantity
    */

    const input = card.querySelector(".qty-input");

    const plus = card.querySelector(".qty-plus");

    const minus = card.querySelector(".qty-minus");

    if (plus) {

      plus.addEventListener("click", () => {
        input.value = Number(input.value) + 1;
      });

    }

    if (minus) {

      minus.addEventListener("click", () => {
        input.value = Math.max(
          1,
          Number(input.value) - 1
        );
      });

    }

  }

  /*
  =====================================
  Initialize Existing Cards
  =====================================
  */

  function initializeCards(scope = document) {

    scope.querySelectorAll(".wholesale-card").forEach(card => {

      initCard(card);

    });

  }

  initializeCards();

  /*
=====================================
AJAX ADD TO CART
=====================================
*/

async function addToCart(button) {

  const variant = button.dataset.variant;

  if (!variant) return;

  let quantity = 1;

  const card = button.closest(".wholesale-card");

  if (card) {
    const qtyInput = card.querySelector(".qty-input");

    if (qtyInput) {
      quantity = Number(qtyInput.value);
    }
  }

  button.disabled = true;
  button.textContent = "Adding...";

  try {

   await fetch("/cart/add.js", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    items: [
      {
        id: Number(variant),
        quantity: quantity
      }
    ]
  })
});

await refreshCartBubble();
await updateShippingBar();

button.textContent = "Added ✓";

    setTimeout(() => {
      button.disabled = false;
      button.textContent = "Add";
    }, 1200);

  } catch (error) {

    console.error(error);

    button.disabled = false;
    button.textContent = "Error";

  }

}

/*
=====================================
Event Delegation
Works for newly loaded products too
=====================================
*/

document.addEventListener("click", function (e) {

  const button = e.target.closest(".ajax-add");

  if (!button) return;

  e.preventDefault();

  addToCart(button);

});

/*
=====================================
Money Format
=====================================
*/

function money(value) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    currencyDisplay: "code"
  })
  .format(value / 100)
  .replace("INR", "Rs.");
}

/*
=====================================
Margin Calculation
=====================================
*/

/*
=====================================
Margin Calculation
=====================================
*/

function calculateMargin(card, variantId, price) {

  const marginBox = card.querySelector("[data-margin]");
  const msrpBox = card.querySelector("[data-msrp-badge]");

  if (!marginBox || !msrpBox) return;

  const msrpPerUnit = Number(msrpBox.dataset.msrp);

  if (!msrpPerUnit) {
    marginBox.textContent = "Margin";
    return;
  }

  const select = card.querySelector(".variant-dropdown");
  const qty = Number(select.options[select.selectedIndex].dataset.qty);

  const totalMsrp = msrpPerUnit * qty;
  const wholesalePrice = price / 100;

  const margin = Math.round(
    ((totalMsrp - wholesalePrice) / totalMsrp) * 100
  );

  marginBox.textContent = margin + "% Margin";

}

/*
=====================================
Free Shipping Progress
=====================================
*/

async function updateShippingBar() {

  try {

    const cart = await fetch("/cart.js").then(res => res.json());

    const total = cart.total_price / 100;

    const remaining = Math.max(0, shippingThreshold - total);

    const text = document.querySelector(".shipping-remaining");
    const fill = document.querySelector(".shipping-bar-fill");

    if (text) {

      if (remaining > 0) {
        text.textContent = "$" + remaining.toFixed(0);
      } else {
        text.textContent = "0";
      }

    }

    if (fill) {

      let percent = (total / shippingThreshold) * 100;

      percent = Math.min(100, percent);

      fill.style.width = percent + "%";

    }

  } catch (error) {

    console.log(error);

  }

}

updateShippingBar();



/*
=====================================
AJAX LOAD MORE
=====================================
*/

const loadMoreBtn = document.getElementById("LoadMoreProducts");

if (loadMoreBtn) {

  loadMoreBtn.addEventListener("click", async function () {

    const nextUrl = this.dataset.nextUrl;

    if (!nextUrl) return;

    this.disabled = true;
    this.textContent = "Loading...";

    try {

      const response = await fetch(nextUrl);

      const html = await response.text();

      const parser = new DOMParser();

      const doc = parser.parseFromString(html, "text/html");

      const newCards = doc.querySelectorAll(".wholesale-card");

      const wrapper = document.querySelector(".wholesale-products");

      newCards.forEach(card => {

        wrapper.appendChild(card);

        // Initialize newly added card
        initCard(card);

      });

      const nextButton = doc.querySelector("#LoadMoreProducts");

      if (nextButton) {

        this.dataset.nextUrl = nextButton.dataset.nextUrl;

        this.disabled = false;

        this.textContent = "Load More Products";

      } else {

        this.remove();

      }

    } catch (error) {

      console.error(error);

      this.disabled = false;

      this.textContent = "Load More Products";

    }

  });

}

});
/*
=====================================
Refresh Cart Bubble
=====================================
*/

async function refreshCartBubble() {

  try {

    const response = await fetch(window.location.pathname + "?section_id=header");

    if (!response.ok) return;

    const html = await response.text();

    const parser = new DOMParser();

    const doc = parser.parseFromString(html, "text/html");

    const newBubble = doc.querySelector("#cart-icon-bubble");
    const currentBubble = document.querySelector("#cart-icon-bubble");

    if (newBubble && currentBubble) {
      currentBubble.replaceWith(newBubble);
    }

  } catch (error) {

    console.error("Cart bubble refresh failed", error);

  }

}

jQuery(function ($) {
    if ($("#shopify-section-template--22403039723779__wholesale_collection_UJzUDY").length) {
        $(".product-grid-section.section-template--22403039723779__product-grid-padding.ignore-true").hide();
    }
});

jQuery(function($) {
  if (window.location.pathname === '/collections/piercing-aftercare-wholesale') {
    $('<style>')
      .html('#Banner-template--22139649261827__banner::after { opacity: 0 !important; }')
      .appendTo('head');
  }
});